import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform, MenuController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { IfscValidator } from 'src/app/validation/ifsc.validator';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-changefrequency',
    templateUrl: './changefrequency.component.html',
    styleUrls: ['./changefrequency.component.scss'],
})

export class ChangeFrequency implements OnInit {
    public changefeqform: FormGroup;
    currentpath: any;
    languageConext: any;
    headingTitle: any;
    selfreq: any;
    existingFreq: any;
    formsubmitted: any;
    hiddensubmit : boolean= false;
  userInfo : any;

    constructor(public formBuilder: FormBuilder,
        private router: Router,
        public navctrl: NavController,
        public platform: Platform,
        public cmndeclaration: CommonDeclarationService,
        public cmndef: CommonDefinitionService,
        private camera: Camera,
        public actionSheetController: ActionSheetController,
        private file: File,
        public api: RestapiService,
        private filePath: FilePath,
        private fileChooser: FileChooser,
        private base64: Base64,
        public actionVal: ActionlistenService,
        public _sanitizer: DomSanitizer,
        public menuCtrl: MenuController) {

        if (this.cmndeclaration.LanguageJson) {
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].frequencychange;
        }
        else {
            this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
            this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].frequencychange;
        }
        this.headingTitle = this.languageConext.heading.text;

        this.changefeqform = formBuilder.group({
            selfreq: ['', Validators.required]
        });
        this.cmndeclaration.getstoreProcess('profile').then(data=>{
            this.userInfo = data;
            var req = {
                "userSessionID": localStorage.userSessionID,
                "userChatSessionId": localStorage.userChatSessionId,
                "mobileNo": this.userInfo.mobileNo,
                "requestType":"getFrequency",
            }
            this.api.postapi("updateDetails", req).then(response => {
                if (response['responseCode'] == '001') {
                    this.existingFreq = response['Frequency'];
                 }
    
                })
        });
    }

    ionViewWillEnter() {
        this.menuCtrl.swipeEnable(false);
      }

    change(){
        if(this.existingFreq=="Quarterly" && this.selfreq=="Monthly"){
            this.hiddensubmit =true;
        }
        else{
            this.hiddensubmit=false;
        }
    }

    ngOnInit() {
    }

    async  submit() {
        if (this.changefeqform.valid && this.selfreq != this.existingFreq) {
            this.cmndef.loaderstart();
            var data = {
                "userSessionID": localStorage.userSessionID,
                "userChatSessionID": localStorage.userChatSessionId,
                "actionType": "Frequency_Change",
                "FrequencyDetails": {
                    "oldFrequency": this.existingFreq,
                    "newFrequency": this.selfreq
                  }
            }
            this.api.clickenventcap("submit_"+this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
            await this.api.postapi("akeiraVAAction", data).then(async data => {
                let res = data;
                this.cmndef.loaderend();
                this.cmndeclaration.TamlismaJson = res["chatResp"][0];
                sessionStorage.CurrentPage = "/va/chat";
                this.navctrl.navigateForward("/va/chat");
            },err=>{
                console.log(err);
                this.cmndef.loaderend();
            })
        }

    }



}
